<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <div class="map">
    <div id="map" :style="mapstyle"></div>
    <a-modal title="泵房信息" width="40%" :footer="null" :visible="visible" @ok="handleOk" @cancel="handleCancel">
      <div id="tab">
        <a-tabs default-active-key="1" @change="callback">
          <a-tab-pane key="1" tab="基础资料">
            <a-card>
              <p>
                泵房名称:<span id="cardinfo">{{ pumpinfo.pumpName }}</span>
              </p>
              <p>
                泵房编号:<span id="cardinfo">{{ pumpinfo.pumpNo }}</span>
              </p>
              <p v-if="pumpinfo.pumpUrl !== ''">
                泵房图片:<span id="cardinfo">
                  <img :src="pumpinfo.pumpUrl" :alt="pumpinfo.pumpUrl" style="width: 100%; height: 100%" /></span>
              </p>
              <p>
                用户数:<span id="cardinfo">{{ pumpinfo.userNum }}</span>
              </p>
              <p>
                建造年代:<span id="cardinfo">{{ pumpinfo.buildingTime }}</span>
              </p>
              <p>
                泵房地址:<span id="cardinfo">{{ pumpinfo.address }}</span>
              </p>
            </a-card>
          </a-tab-pane>
          <a-tab-pane key="2" tab="工艺图" force-render v-if="pumpinfo.flowUrl !== ''">
            <a-card>
              <p>
                <img :src="pumpinfo.flowUrl" :alt="pumpinfo.flowUrl" style="width: 100%; height: 100%" />
              </p>
            </a-card>
          </a-tab-pane>
          <a-tab-pane key="3" tab="监控视频">
            <div id="vidio"></div>
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-modal>
  </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
import EZUIKit from 'ezuikit-js'
import Map from 'ol/Map'
import TileLayer from 'ol/layer/Tile'
import View from 'ol/View'
import XYZ from 'ol/source/XYZ'
import VectorSource from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'
import Feature from 'ol/Feature'
import Stroke from 'ol/style/Stroke'
import Fill from 'ol/style/Fill'
import Point from 'ol/geom/Point'
import Style from 'ol/style/Style'
import Icon from 'ol/style/Icon'
import Text from 'ol/style/Text'
import Scanler from 'ol/control/ScaleLine'
import * as olProj from 'ol/proj'
export default {
  data () {
    return {
      mapstyle: {
        width: '100%',
        height: '600px'
      },
      vidioUrl: '',
      queryUrl: '/pipe-network/twice_water_pumps/page',
      map: null,
      mapcenter: [],
      pumpinfo: {},
      pumpHouseList: [],
      icon: '/iconImg/icon-bf-def.png',
      visible: false,
      coordinate: '',
      player: null,
      list: [],
      vidioinfo: []
    }
  },
  computed: {
    title () {
      return `${this.$store.getters.userInfo.tenant.shortName}智慧管理平台`
    },
    currentUser () {
      return this.$store.getters.userInfo
    },
    token () {
      return this.$store.getters.token
    }
  },
  created () {
    this.gettoken()
  },
  mounted () {
    this.initMap()
    this.addMarker()
  },
  methods: {
    initMap () {
      console.log('二供initMap')
      const gcj02Extent = [-20037508.342789244, -20037508.342789244, 20037508.342789244, 20037508.342789244]
      const gcjMecator = new olProj.Projection({
        code: 'GCJ-02',
        extent: gcj02Extent,
        units: 'm'
      })
      olProj.addProjection(gcjMecator)
      olProj.addCoordinateTransforms('EPSG:4326', gcjMecator, window.projzh.ll2gmerc, window.projzh.gmerc2ll)
      olProj.addCoordinateTransforms('EPSG:3857', gcjMecator, window.projzh.smerc2gmerc, window.projzh.gmerc2smerc)
      this.mapcenter = this.currentUser.tenant.point
      this.map = new Map({
        view: new View({
          center: this.mapcenter, // 中心点, 填的是经纬度
          projection: 'EPSG:4326', // EPSG:4326格式的经纬度
          zoom: 15, // 地图默认缩放级别
          maxZoom: 19, // 地图最大缩放级别
          minZoom: 1 // 地图最小缩放级别
        }),
        target: 'map' // 地图容器id
      })
      var roadLayer = new TileLayer({
        title: '高德地图',
        source: new XYZ({
          projection: gcjMecator,
          crossOrigin: 'anonymous',
          tileUrlFunction: this.tileUrlFunction
        })
      })
      var scanler = new Scanler()
      this.map.addLayer(roadLayer)
      this.map.addControl(scanler)
    },
    tileUrlFunction (coord, params1, params2) {
      return this.getVETileUrl(coord[0], coord[1], coord[2])
    },
    getVETileUrl (z, x, y) {
      for (var a = '', c = x, d = y, e = 0; e < z; e++) {
        a = ((c & 1) + 2 * (d & 1)).toString() + a
        c >>= 1
        d >>= 1
      }
      return 'http://dynamic.t0.tiles.ditu.live.com/comp/ch/' + a + '?it=G,VE,BX,L,LA&mkt=zh-cn,syr&n=z&og=111&ur=CN'
    },
    addMarker () {
      console.log('addMarker===')
      this.$http.get(this.queryUrl).then((resolve) => {
        console.log(JSON.stringify(resolve.data.list))
        this.mapcenter = resolve.data.list[0].geoJson.split(',')
        console.log('addMarker===', this.mapcenter)
        this.map.getView().setCenter(this.mapcenter)
        resolve.data.list.map((item) => {
          const coordinate = item.geoJson.split(',')
          let properties
          if (item.isOnline === '在线' && item.isWarning === '正常') {
            properties = '/iconImg/bf-l.png'
          }
          if (item.isOnline === '在线' && item.isWarning === '预警') {
            properties = '/iconImg/bf-c.png'
          }
          if (item.isOnline === '在线' && item.isWarning === '报警') {
            properties = '/iconImg/bf-h.png'
          }
          if (item.isOnline === '离线') {
            properties = '/iconImg/bf-hui.png'
          }
          this.addSimplePoint(item.pumpName, coordinate[0], coordinate[1], properties)
        })
      })

      var that = this
      this.map.on('click', function (e) {
        console.log('click=====map')
        var pixel = e.target.getPixelFromCoordinate(e.coordinate)
        var getfeature = e.target.getFeaturesAtPixel(pixel)
        for (const i in getfeature) {
          console.log(i)
        }
        getfeature.map((item) => {
          console.log(item.values_.geometry.flatCoordinates)
          that.coordinate = item.values_.geometry.flatCoordinates
          console.log(that.coordinate[0])
          that.getlistbycoord(`${that.coordinate[0]},${that.coordinate[1]}`)
          that.showModal()
          //    console.log(JSON.stringify(item));
        })
      })
    },
    addSimplePoint (name, x, y, properties) {
      const point = new Point([x, y])
      const feature = new Feature({
        geometry: point,
        name: name,
        properties: properties,
        remark: '泵房'
      })
      const vectorSource = new VectorSource()
      vectorSource.addFeature(feature)
      const vectorLayer = new VectorLayer({
        source: vectorSource,
        style: this.stylefunction
      })
      this.map.addLayer(vectorLayer)
    },
    stylefunction (feature) {
      const name = feature.get('name')
      const properties = feature.get('properties')
      return new Style({
        fill: new Fill({
          // 填充样式
          color: 'rgba(255, 255, 255,0.2)'
        }),
        stroke: new Stroke({
          // 线样式
          color: '#00c033',
          width: 2
        }),
        image: new Icon({
          src: properties, // this.icon,
          scale: 0.5
        }),
        text: new Text({
          text: name,
          font: '16px Calibri,sans-serif',
          textAlign: 'center',
          offsetX: 0,
          offsetY: 25,
          fill: new Fill({
            color: '#87481f'
          })
        })
      })
    },
    showModal () {
      this.visible = true
      console.log(this.vidioUrl)
    },
    handleOk (e) {
      this.visible = false
      if (this.player) {
        this.vidioUrl = ''
        this.player.stop()
      }
    },
    handleCancel (e) {
      this.visible = false
      if (this.player) {
        this.vidioUrl = ''
        this.player.stop()
      }
    },
    getlistbycoord (geojson) {
      const url = '/pipe-network/twice_water_pumps/page'
      const data = {
        geoJson: geojson
      }

      this.$http({
        url: url,
        params: data,
        method: 'get'
      }).then((resolve) => {
        resolve.data.list.map((item) => {
          console.log(JSON.stringify(item))
          this.pumpinfo = item
          const _url = '/pipe-network/water_works_monitors/page'
          const _data = {
            pointName: item.pumpName
          }
          this.$http({
            url: _url,
            params: _data,
            method: 'get'
          }).then((resolve) => {
            if (parseInt(resolve.data.total) > 0) {
              resolve.data.list.map((item) => {
                this.vidioUrl = item.monitorUrl
                console.log(this.vidioUrl)
              })
            } else {
              if (this.player) {
                this.player.stop()
              }
            }
          })
        })
      })
    },
    gettoken () {
      const url = '/pipe-network/water_works_configurations/page'
      this.$http.get(url).then((resolve) => {
        // console.log(JSON.stringify(resolve.data.list))
        resolve.data.list.map((item) => {
          this.vidioinfo = item
        })
      })
    },
    vidioinit () {
      if (!this.player) {
        this.player = new EZUIKit.EZUIKitPlayer({
          id: 'vidio', // 视频容器ID
          accessToken: this.vidioinfo.token,
          url: this.vidioUrl,
          width: 740,
          height: 500,
          handleError: (e) => {
            if (e.data.retcode == 10002) {
              this.resettoken(this.vidioinfo.appKey, this.vidioinfo.appSecret)
            }
          }
        })
        if (this.vidioUrl !== '') {
          this.player.play()
        }
      } else {
        this.player.stop().then(() => {
          this.player.play(this.url)
        })
        return false
      }
    },
    callback (key) {
      switch (key) {
        case '1':
          console.log(key)
          break
        case '2':
          console.log(key)
          break
        case '3':
          this.$nextTick(() => {
            this.vidioinit()
          })
          break
      }
    },
    resettoken (appkey, appsecret) {
      const url = 'https://open.ys7.com/api/lapp/token/get'
      const header = {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
      const that = this
      const data = { appKey: appkey, appSecret: appsecret }
      axios.post(url, qs.stringify(data), {
        headers: header
      })
        .then((response) => {
          if (response.data.code === 200) {
            console.log(JSON.stringify(response.data))
            const token = response.data.data.accessToken
            that.vidioinfo.token = response.data.data.accessToken
            const _header = {
              'Content-Type': 'application/json',
              Authorization: that.token
            }
            const params = {
              id: that.vidioinfo.id,
              token: token
            }
            that.$http({
              url: '/pipe-network/water_works_configurations',
              method: 'put',
              data: params,
              header: _header
            })
              .then((data) => {
                // console.log(JSON.stringify(data))
                that.vidioinit()
              })
              .catch((resolve) => {
                console.log(JSON.stringify(resolve))
              })
          } else {
            that.$message.error(response.data.msg)
          }
        })
        .catch((resolve) => {
          // console.log(resolve.data.code);
        })
    }
  }
}
</script>

<style scoped>
.map {
  width: 100%;
  height: 100%;
  position: relative;
}

#tab {
  margin-top: -30px;
}

#vidio {
  width: 740px;
  height: 500px;
}

#cardinfo {
  margin-left: 10px;
}
</style>
